<template>
  <div class="flex gap-x-4 items-center mb-12">
    <div class="w-auto">
      <h3 class="text-3xl font-semibold"><slot /></h3>
    </div>
    <slot name="filters" />
    <div class="grow text-end">
      <slot name="buttons" />
    </div>
  </div>
</template>